import { ID } from "./id"
import { Topics } from "./topics";

export enum ImplementationMode {
  SINGLE = '1',
  MULTI = '2',
  MULTIFIXED = '3',
  HISTORY = '4'
}

export const InterfaceName = {
  CLIENTE: "1",
  CONTRATTO: "2",
  ASSETS: "3",
  RIFERIMENTI: "4",
  OLO_REQUEST: "5",
  CONDOMINIO: "6",
  SERVIZIO_AGGIUNTIVO: "7",
  APPARATO: "8",
  CHECKLIST: "9",
  RICHIESTA_PERMESSO: "10",
  RISPOSTA: "11",
  ACQUISIZIONE_NEGATIVA: "12",
  ACCETTAZIONE_NEGATIVA: "13",
  APPUNTAMENTO: "14",
  ESPLETAMENTO_NEGATIVO: "15",
  ESPLETAMENTO_POSITIVO: "16",
  ANNULLATO: "17",
  OLO_COMMUNICATION: "18",
  OLO_SOSPENSIONE: "19",
  EP_TICKET: "20",
  ORDINE_OLO: "21",
  RISPOSTA_SOLLECITO: "22",
  INSTALLAZIONE: "23",
  OLO_RISOLUZIONE: "24",
  GENERIC_SUSPENSION: "25",
  OLO_RISORSA: "26",
  OLO_RIFERIMENTI_UI: "27",
  SUPPORT: "28", //editable
  OLO_DEACTIVATION: "29", //readonly
  OLO_DEACTIVATION_VALIDATION: "30", //readonly
  OLO_DEACTIVATION_PHYSIC: "31", //readonly
  GENERIC_KO: "32", //hidden
  MAIL_GTW_SOURCE: "33", //readonly
  GR_RESOURCES: "gr_resources", //readonly
  GR_TASKS: "gr_tasks", //readonly
  GR_RESOURCES_MAP: "gr_resources_map", //readonly
  GISFO_WORKORDER: "gisfo_workorder", //readonly
  ACTIVATION_REQUEST: "activation_request",
  ASSURANCE_TICKET: "assurance_ticket",
  GENERIC_OK: "generic_ok",
  NETWORK_ITEMS: "network_items",
  FAULT_MANAGEMENT: "fault_management",
  GENERIC_APPOINTMENT: "generic_appointment",
  OLO_REQUEST_OF: "olo_request_of",
  OLO_RISORSA_PNI: "olo_resource_pni",
  ESPLETAMENTO_POSITIVO_OF: "espletamento_positivo_of",
  ISSUE_LINK: "issue_link",
  ISSUE_LINKED: "issue_linked",
  SLA_EDITOR: "sla_editor",
  RISORSA_LORA: "risorsa_lora",
  CHECKLIST_GISFO: "checklist_gisfo",
  ESPLETATO_OK_CHECKLIST_GISFO: "espletato_ok_checklist_gisfo",
  PORTALE_CONTRATTI: "portale_contratti",
  IID_CONFERMA_APPUNTAMENTO: "conferma_appuntamento",
  IID_OLO_POP_SVLAN: "iid_olo_pop_svlan",
  RISORSE_CREATION: "risorse_creation",
  IID_RISORSE_VERIFICA: "risorse_verifica",
  RISORSE_PERMESSO_PUBBLICO: "risorse_permesso_pubblico",
  RISORSE_IRU_ACQUISIZIONE: "risorse_iru_acquisizione",
  APPARATO_SPLITTER: "apparato_splitter",
  IID_PRATICA_IRU_CUSTOMER: "iid_pratica_iru_customer",
  IID_PRATICA_IRU_PROVIDER: "iid_pratica_iru_provider",
  UNLOCK_CODE: "unlock_code",
  IID_FEASABILITY_CONNECTION_REQUEST: "iid_feasability_connection_request",
  IID_FEASABILITY_REQUEST_IDENTIFIER: "iid_feasability_request_identifier",
  IID_FEASABILITY_RESPONSE: "iid_feasability_response",
  IID_FEASABILITY_ASSOCIATION: "iid_feasability_association",
} as const;

//TODO: questa cosa andrebbe resa dinamica, da discutere come poterla strutturare nel database per esempio
export const TopicToInterfaceMap: Partial<Record<Topics, string>> = {
  [Topics.IID_OL_CLIENTE]: InterfaceName.CLIENTE,
  [Topics.IID_OL_CONTRATTO]: InterfaceName.CONTRATTO,
  [Topics.IID_EP_ASSETS]: InterfaceName.ASSETS,
  [Topics.IID_OL_RIFERIMENTI]: InterfaceName.RIFERIMENTI,
  [Topics.IID_OL_OLO_REQUEST]: InterfaceName.OLO_REQUEST,
  [Topics.IID_OL_CONDOMINIO]: InterfaceName.CONDOMINIO,
  [Topics.IID_OL_SERVIZIO_AGGIUNTIVO]: InterfaceName.SERVIZIO_AGGIUNTIVO,
  [Topics.IID_OL_APPARATO]: InterfaceName.APPARATO,
  [Topics.IID_OL_CHECKLIST]: InterfaceName.CHECKLIST,
  [Topics.IID_EP_RICHIESTA_PERMESSO]: InterfaceName.RICHIESTA_PERMESSO,
  [Topics.IID_EP_RISPOSTA]: InterfaceName.RISPOSTA,
  [Topics.IID_OL_ACQUISITO_KO]: InterfaceName.ACQUISIZIONE_NEGATIVA,
  [Topics.IID_OL_ACCETTATO_KO]: InterfaceName.ACCETTAZIONE_NEGATIVA,
  [Topics.IID_OL_ESPLETATO_KO]: InterfaceName.ESPLETAMENTO_NEGATIVO,
  [Topics.IID_OL_ESPLETATO_OK]: InterfaceName.ESPLETAMENTO_POSITIVO,
  [Topics.IID_OL_ANNULLATO]: InterfaceName.ANNULLATO,
  [Topics.IID_OL_COMMUNICATION]: InterfaceName.OLO_COMMUNICATION,
  [Topics.IID_OL_SOSPENSIONE]: InterfaceName.OLO_SOSPENSIONE,
  [Topics.IID_EP_TICKET]: InterfaceName.EP_TICKET,
  [Topics.IID_OL_RISPOSTA_SOLLECITO]: InterfaceName.RISPOSTA_SOLLECITO,
  [Topics.IID_OL_SUPPORTO]: InterfaceName.SUPPORT,
  [Topics.IID_OLO_DEACTIVATION]: InterfaceName.OLO_DEACTIVATION,
  [Topics.IID_OLO_DEACTIVATION_VALIDATION]: InterfaceName.OLO_DEACTIVATION_VALIDATION,
  [Topics.IID_OLO_DEACTIVATION_PHYSIC]: InterfaceName.OLO_DEACTIVATION_PHYSIC,
  [Topics.IID_GENERIC_KO]: InterfaceName.GENERIC_KO,
  [Topics.IID_MAIL_GTW_SOURCE]: InterfaceName.MAIL_GTW_SOURCE,
  [Topics.IID_GR_RESOURCES]: InterfaceName.GR_RESOURCES,
  [Topics.IID_GR_TASKS]: InterfaceName.GR_TASKS,
  [Topics.IID_GISFO_WORKORDER]: InterfaceName.GISFO_WORKORDER,
  [Topics.IID_OL_ACTIVATION_REQUEST]: InterfaceName.ACTIVATION_REQUEST,
  [Topics.IID_ASSURANCE_TICKET]: InterfaceName.ASSURANCE_TICKET,
  [Topics.IID_APPARATO_SPLITTER]: InterfaceName.APPARATO_SPLITTER,
  [Topics.IID_GENERIC_OK]: InterfaceName.GENERIC_OK,
  [Topics.IID_NETWORK_ITEMS]: InterfaceName.NETWORK_ITEMS,
  [Topics.IID_FAULT_MANAGEMENT]: InterfaceName.FAULT_MANAGEMENT,
  [Topics.IID_GENERIC_APPOINTMENT]: InterfaceName.GENERIC_APPOINTMENT,
  [Topics.IID_OL_OLO_REQUEST_OF]: InterfaceName.OLO_REQUEST_OF,
  [Topics.IID_OL_RISORSA_PNI]: InterfaceName.OLO_RISORSA_PNI,
  [Topics.IID_ISSUE_LINK]: InterfaceName.ISSUE_LINK,
  [Topics.IID_ISSUE_LINKED]: InterfaceName.ISSUE_LINKED,
  [Topics.IID_SLAEDITOR]: InterfaceName.SLA_EDITOR,
  [Topics.IID_RISORSA_LORA]: InterfaceName.RISORSA_LORA,
  [Topics.IID_CHECKLIST_GISFO]: InterfaceName.CHECKLIST_GISFO,
  [Topics.IID_ESPLETATO_OK_CHECKLIST_GISFO]: InterfaceName.ESPLETATO_OK_CHECKLIST_GISFO,
  [Topics.IID_PORTALE_CONTRATTI]: InterfaceName.PORTALE_CONTRATTI,
  [Topics.IID_RISORSE_CREATION]: InterfaceName.RISORSE_CREATION,
  [Topics.IID_RISORSE_VERIFICA]: InterfaceName.IID_RISORSE_VERIFICA,
  [Topics.IID_RISORSE_PERMESSO_PUBBLICO]: InterfaceName.RISORSE_PERMESSO_PUBBLICO,
  [Topics.IID_RISORSE_IRU_ACQUISIZIONE]: InterfaceName.RISORSE_IRU_ACQUISIZIONE,
  [Topics.IID_FEASABILITY_CONNECTION_REQUEST]: InterfaceName.IID_FEASABILITY_CONNECTION_REQUEST,
  [Topics.IID_FEASABILITY_REQUEST_IDENTIFIER]: InterfaceName.IID_FEASABILITY_REQUEST_IDENTIFIER,
  [Topics.IID_FEASABILITY_RESPONSE]: InterfaceName.IID_FEASABILITY_RESPONSE,
  [Topics.IID_PRATICA_IRU_CUSTOMER]: InterfaceName.IID_PRATICA_IRU_CUSTOMER,
  [Topics.IID_PRATICA_IRU_PROVIDER]: InterfaceName.IID_PRATICA_IRU_PROVIDER,
  [Topics.IID_UNLOCK_CODE]: InterfaceName.UNLOCK_CODE,
  [Topics.IID_FEASABILITY_ASSOCIATION]: InterfaceName.IID_FEASABILITY_ASSOCIATION,
};

export const InterfaceToTopicMap: Partial<Record<string, Topics>> =
  Object.entries(TopicToInterfaceMap).reduce((acc, [topic, iface]) => {
    if (iface) acc[iface] = topic as Topics;
    return acc;
  }, {} as Partial<Record<string, Topics>>);

export type InterfaceNameKey = keyof typeof InterfaceName;
export type InterfaceNameValue = (typeof InterfaceName)[InterfaceNameKey] | string & {};

export const InterfaceNameEntries = Object.entries(InterfaceName) as [InterfaceNameKey, InterfaceNameValue][];

export const INTERFACE_GENERIC_PROPERTIES = ['projectId', 'issueId', 'archivedAt', 'version', 'isValid', 'id', 'deletedAt',
  'updatedAt', 'createdAt', 'createdBy', 'lastUpdatedBy'];

export const getInterfaceNameKeyFromValue = (value: InterfaceNameValue): any => {
  const key = Object.entries(InterfaceName).find(c => c[1] === value);
  return (key ? key[0] : null);
};

export const getTranslationInterfaceName = (interfaceName: InterfaceNameValue): any => {
  return `INTERFACES._TITLES.${getInterfaceNameKeyFromValue(interfaceName)?.toUpperCase() ?? interfaceName}`;
};

export const getTranslationInterfaceProperty = (interfaceName: InterfaceNameValue, prop: string): any => {
  return INTERFACE_GENERIC_PROPERTIES.includes(prop) ?
    `INTERFACES._GENERIC.${prop.toUpperCase()}`
    : `INTERFACES.${getInterfaceNameKeyFromValue(interfaceName)?.toUpperCase() ?? interfaceName}.${prop.toUpperCase()}`
};

export const getInterfaceNameFromKey = (key: InterfaceNameKey | string & {}) => {
  const found = Object.entries(InterfaceName).find(([k, v]) => k === key)
  if (!found) {
    return null;
  }
  return {
    key: found[0],
    value: found[1],
  }
};

export const getInterfaceNameFromValue = (value: InterfaceNameValue | string & {}) => {
  const found = Object.entries(InterfaceName).find(([k, v]) => v === value)
  if (!found) {
    return null;
  }
  return {
    key: found[0],
    value: found[1],
  }
};

export function topicToInterfaceName(topic: Topics): string | undefined {
  return TopicToInterfaceMap[topic];
}

// Modificare con cautela!
export interface InterfaceOption {
  interfaceName: InterfaceNameValue;
  typeInterfaceName: string;
}

export interface IIssueTypeInterface {
  id: ID;
  order: number;
  implementationMode: ImplementationMode;
  interfaceName: InterfaceNameValue;
  label: string;
  name: string;
  issueTypeId: ID;
  createdAt: string;
  updatedAt: string;
}

export interface TabsState {
  modal: string | null;
  route: string;
  recentTabIndex: number;
}
export interface NavigationState {
  route: string;
  openedModal: string;
  issueId?: string;
  tabsState: TabsState[];
}

export interface VlanServices {
  svlan: string;
  cvlan: number;
  userVlan: string;
}

export function getInterfaceNameIterable(): InterfaceNameValue[] {
  return Object.values(InterfaceName);
  // const result: InterfacesValues[] = [];
  // for (const value in InterfaceName) {
  //   const index = parseInt(value);
  //   if (!isNaN(index)) {
  //     result.push(index as InterfaceName)
  //   }
  // }
  // return result;
}
